import { useMutation } from '@tanstack/react-query';

import { exponentialRetryDelay } from '@/lib/react-query/exponentialRetryDelay';
import {
  ScoutApiError,
  scoutClient,
} from '@/modules/scout-sourcing/scoutClient';
import type { ScoutPreviewChampionQueryResponse } from '@/modules/scout-sourcing/types';

type Payload = {
  jobId: string;
  jobSourcingId: string;
};

export const usePreviewChampionQueryMutation = () =>
  useMutation<ScoutPreviewChampionQueryResponse, Error, Payload>({
    mutationFn: ({ jobId, jobSourcingId }) =>
      scoutClient.previewQuery(jobId, jobSourcingId),
    retry: (failureCount, error) =>
      failureCount < 2 &&
      (!(error instanceof ScoutApiError) || error.status >= 500),
    retryDelay: (attemptIndex) => exponentialRetryDelay(attemptIndex, 3000),
  });
